import { render } from "./audienceList.vue?vue&type=template&id=190fc526&scoped=true"
import script from "./audienceList.vue?vue&type=script&lang=js"
export * from "./audienceList.vue?vue&type=script&lang=js"

import "./audienceList.vue?vue&type=style&index=0&id=190fc526&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190fc526"]])

export default __exports__